import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'

import logo from '../../components/Header/logo.png'

import { ADMIN_MOVED_REDIRECT_DELAY, ADMIN_MOVED_URL } from '~constants'

export const AdminMovedPage = () => {
  const { t } = useTranslation()
  const [seconds, setSeconds] = useState(ADMIN_MOVED_REDIRECT_DELAY)

  useEffect(() => {
    if (seconds <= 0) {
      window.location.assign(ADMIN_MOVED_URL)
      return
    }
    const timer = setTimeout(() => setSeconds((value) => value - 1), 1000)
    return () => clearTimeout(timer)
  }, [seconds])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow">
        <img className="mx-auto h-12 w-auto" src={logo} alt="Hop-On Ticketing" />

        <h1 className="mt-8 text-xl font-semibold text-gray-900">
          {t('AdminMoved.title', 'The admin has moved')}
        </h1>

        <p className="mt-3 text-sm text-gray-600">
          {t(
            'AdminMoved.description',
            'This admin is no longer hosted here. It now lives at a new address.',
          )}
        </p>

        <a
          href={ADMIN_MOVED_URL}
          className="mt-6 inline-flex w-full items-center justify-center gap-x-2 rounded-lg border border-transparent bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2">
          {t('AdminMoved.button', 'Go to the new admin')}
          <ArrowTopRightOnSquareIcon className="h-4 w-4" aria-hidden="true" />
        </a>

        <p className="mt-4 text-xs text-gray-400" aria-live="polite">
          {seconds > 0
            ? t('AdminMoved.redirecting', 'Redirecting automatically in {{seconds}}s…', { seconds })
            : t('AdminMoved.redirectingNow', 'Redirecting…')}
        </p>

        <p className="mt-6 break-all text-xs text-gray-400">{ADMIN_MOVED_URL}</p>
      </div>
    </div>
  )
}
